(function () {
  'use strict';
 
  /* ---------- helpers ---------------------------------------------------- */
  function getExpressWishlistId() {
    /* Reads the "wishlist_id" cookie set by Smart Wishlist for guest users */
    try {
      var cookies = decodeURIComponent(document.cookie).split(';');
      for (var i = 0; i < cookies.length; i++) {
        var c = cookies[i].trim();
        if (c.indexOf('wishlist_id=') === 0) return c.substring('wishlist_id='.length);
      }
    } catch (e) { /* silent */ }
    return '';
  }
 
  function formatMoney(amountStr, format) {
    /* Smart Wishlist returns price as a formatted string like "Rs.4,870.00".
       We display it as-is because the app already formats to the store's currency. */
    if (!amountStr) return '';
    return amountStr;
  }
 
  function sizedImage(url, width) {
    if (!url) return '';
    /* Shopify CDN images can be resized via _WIDTHx in the filename */
    return url.replace(/(\.\w{3,4})(\?|$)/, '_' + width + 'x$1$2');
  }
 
  function tone(text) {
    var sum = 0;
    for (var i = 0; i < (text || '').length; i++) sum += text.charCodeAt(i);
    return String(sum % 5);
  }
 
  /* ----------------------------------------------------------- page element */
  class WishlistPage extends HTMLElement {
    connectedCallback() {
      this.rootUrl = this.dataset.rootUrl || '/';
      this.moneyFormat = this.dataset.moneyFormat || '₹{{amount}}';
      this.customerId = this.dataset.customerId || '0';
      this.wishlistApiPath = this.dataset.wishlistApiPath || '/a/wishlist';
 
      this.card = this.querySelector('[data-wl-card]');
      this.list = this.querySelector('[data-wl-items]');
      this.empty = this.querySelector('[data-wl-empty]');
      this.loading = this.querySelector('[data-wl-loading]');
      this.toolbar = this.querySelector('[data-wl-toolbar]');
      this.counter = this.querySelector('[data-wl-count]');
      this.toastEl = this.querySelector('[data-wl-toast]');
      this.rowTemplate = this.querySelector('[data-wl-row-template]');
 
      this.addEventListener('click', this.onClick.bind(this));
      this.render();
    }
 
    /* --- Smart Wishlist Public API ---------------------------------------- */
    buildApiUrl() {
      var base = this.wishlistApiPath + '?type=api&version=1';
      if (this.customerId && this.customerId !== '0') {
        return base + '&customerid=' + this.customerId;
      }
      var expressId = getExpressWishlistId();
      if (expressId) {
        return base + '&wishlistid=' + expressId;
      }
      return base;
    }
 
    async fetchWishlistItems() {
      try {
        var url = this.buildApiUrl() + '&_=' + Date.now(); /* cache-bust */
        var response = await fetch(url);
        if (!response.ok) return [];
        var data = await response.json();
        if (!data || parseInt(data.count) === 0) return [];
        return data.items || [];
      } catch (e) {
        console.error('Smart Wishlist API error:', e);
        return [];
      }
    }
 
    /* --- render ----------------------------------------------------------- */
    async render() {
      this.empty.hidden = true;
      this.card.hidden = true;
      this.toolbar.hidden = true;
      this.loading.hidden = false;
 
      var items = await this.fetchWishlistItems();
 
      if (!items.length) {
        this.loading.hidden = true;
        this.card.hidden = true;
        this.toolbar.hidden = true;
        this.empty.hidden = false;
        this.setCount(0);
        return;
      }
 
      /* For each item, optionally enrich with live storefront data */
      var self = this;
      var enriched = await Promise.all(items.map(async function (item) {
        try {
          var resp = await fetch(self.rootUrl.replace(/\/$/, '') + '/products/' + item.handle + '.js');
          if (!resp.ok) return { swItem: item, product: null };
          var product = await resp.json();
          return { swItem: item, product: product };
        } catch (e) {
          return { swItem: item, product: null };
        }
      }));
 
      this.list.innerHTML = '';
      enriched.forEach(function (entry) { self.list.appendChild(self.buildRow(entry)); });
 
      this.loading.hidden = true;
      this.card.hidden = false;
      this.toolbar.hidden = false;
      this.setCount(enriched.length);
    }
 
    setCount(count) {
      var word = count === 1 ? this.dataset.textItem : this.dataset.textItems;
      this.counter.textContent = count + ' ' + word;
    }
 
    buildRow({ swItem, product }) {
      var row = this.rowTemplate.content.firstElementChild.cloneNode(true);
 
      var productId = swItem.id || (product ? product.id : '');
      var variantId = swItem.variant_id || (product ? product.variants[0].id : '');
      var handle = swItem.handle || (product ? product.handle : '');
 
      var url = this.rootUrl.replace(/\/$/, '') + '/products/' + handle;
 
      row.dataset.handle = handle;
      row.dataset.productId = productId;
      row.dataset.variantId = variantId;
 
      row.querySelectorAll('[data-wl-link]').forEach(function (link) { link.href = url; });
 
      /* Image — prefer live product data, fall back to Smart Wishlist data */
      var image = row.querySelector('[data-wl-image]');
      var imgSrc = '';
      if (product && product.featured_image) {
        imgSrc = product.featured_image;
      } else if (swItem.image) {
        imgSrc = swItem.image;
      }
      image.src = imgSrc ? sizedImage(imgSrc, 260) : '';
      image.alt = swItem.title || (product ? product.title : '');
 
      /* Title */
      row.querySelector('[data-wl-title]').textContent = swItem.title || (product ? product.title : '');
 
      /* Vendor badge */
      var vendor = row.querySelector('[data-wl-vendor]');
      var vendorName = product ? product.vendor : '';
      if (vendorName) {
        vendor.textContent = vendorName;
        vendor.dataset.tone = tone(vendorName);
        vendor.hidden = false;
      }
 
      /* SKU */
      var sku = row.querySelector('[data-wl-sku]');
      if (product) {
        var variant = product.variants.find(function (v) { return v.id == variantId; }) || product.variants[0];
        if (variant && variant.sku) {
          sku.textContent = 'SKU: ' + variant.sku;
          sku.hidden = false;
        }
      }
 
      /* Stock — used only to disable ATC when out of stock */
      var available = true;
      if (product) {
        var matchedVariant = product.variants.find(function (v) { return v.id == variantId; }) || product.variants[0];
        available = !!(matchedVariant && matchedVariant.available);
      }
 
      /* Price — use live data if available, else Smart Wishlist data */
      if (product) {
        var pVariant = product.variants.find(function (v) { return v.id == variantId; }) || product.variants[0];
        var price = pVariant ? pVariant.price : product.price;
        var compare = pVariant ? pVariant.compare_at_price : product.compare_at_price;
        var moneyFmt = this.moneyFormat;
 
        row.querySelector('[data-wl-price]').textContent = this.formatCents(price, moneyFmt);
 
        if (compare && compare > price) {
          var was = row.querySelector('[data-wl-compare]');
          was.textContent = this.formatCents(compare, moneyFmt);
          was.hidden = false;
 
          var save = row.querySelector('[data-wl-save]');
          save.textContent = Math.round(((compare - price) / compare) * 100) + '% ' + this.dataset.textOff;
          save.hidden = false;
        }
      } else {
        /* Fallback: Smart Wishlist returns pre-formatted price strings */
        row.querySelector('[data-wl-price]').textContent = swItem.variant_price || '';
      }
 
      /* Disable add to cart if out of stock */
      var atc = row.querySelector('.wl-row__atc');
      if (!available) {
        atc.disabled = true;
        row.querySelector('[data-wl-atc-label]').textContent = this.dataset.textOutOfStock;
      }
 
      return row;
    }
 
    formatCents(cents, format) {
      var placeholder = /\{\{\s*(\w+)\s*\}\}/;
      var formatString = format || '₹{{amount}}';
      var match = formatString.match(placeholder);
      if (!match) return formatString;
 
      function withDelimiters(number, precision, thousands, decimal) {
        precision = isNaN(precision) ? 2 : precision;
        thousands = thousands || ',';
        decimal = decimal || '.';
        if (isNaN(number) || number === null) return '0';
        var value = (number / 100).toFixed(precision);
        var parts = value.split('.');
        var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        return whole + (parts[1] ? decimal + parts[1] : '');
      }
 
      var value;
      switch (match[1]) {
        case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
        case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
        case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
        default: value = withDelimiters(cents, 2);
      }
      return formatString.replace(placeholder, value);
    }
 
    /* --- interactions ---------------------------------------------------- */
    onClick(event) {
      var trigger = event.target.closest('[data-wl-action]');
      if (!trigger) return;
 
      var action = trigger.dataset.wlAction;
      var row = trigger.closest('[data-wl-row]');
      event.preventDefault();
 
      if (action === 'remove') this.removeRow(row);
      if (action === 'add') this.addToCart(row, trigger);
      if (action === 'add-all') this.addAllToCart(trigger);
      if (action === 'clear') this.clearAll();
      if (action === 'share') this.share();
    }
 
    removeRow(row) {
      if (!row) return;
      var productId = Number(row.dataset.productId);
      var variantId = Number(row.dataset.variantId);
 
      row.classList.add('is-removing');
 
      /* Call Smart Wishlist's built-in remove function */
      if (typeof RemoveFromSmartWishlist === 'function') {
        try { RemoveFromSmartWishlist(productId, variantId); } catch (e) { console.error(e); }
      }
 
      var self = this;
      window.setTimeout(function () {
        row.remove();
        var remaining = self.list.querySelectorAll('[data-wl-row]').length;
        self.setCount(remaining);
        if (remaining === 0) {
          self.card.hidden = true;
          self.toolbar.hidden = true;
          self.empty.hidden = false;
        }
        self.updateHeaderBadge();
      }, 200);
    }
 
    updateHeaderBadge() {
      /* Smart Wishlist uses span.swym-wishlist-count or similar — trigger their refresh */
      if (typeof ReloadSmartWishlist === 'function') {
        try { ReloadSmartWishlist(); } catch (e) { /* silent */ }
      }
    }
 
    async postToCart(items) {
      var rootUrl = this.rootUrl.replace(/\/$/, '');
      var response = await fetch(rootUrl + '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      });
      if (!response.ok) {
        var error = await response.json().catch(function () { return {}; });
        throw new Error(error.description || 'Could not add to cart');
      }
      var cartData = await response.json();
 
      /* Delay to let Shopify's backend propagate the cart update.
         First add to an empty cart needs more time than subsequent adds. */
      await new Promise(function (resolve) { setTimeout(resolve, 800); });
 
      /* Fetch fresh section HTML and pass it to the cart drawer's
         renderContents method — the exact same flow as product-form.js */
      var cartDrawer = document.querySelector('cart-drawer');
      
      if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
        try {
          var sectionsResponse = await fetch(rootUrl + '/?sections=cart-drawer,cart-icon-bubble');
          var sectionsData = await sectionsResponse.json();
          
          var productId = cartData.product_id || (cartData.items && cartData.items[0] ? cartData.items[0].product_id : 0);
          
          cartDrawer.renderContents({
            id: productId,
            sections: sectionsData
          });
 
          /* Force-remove the empty state in case section HTML still had it */
          setTimeout(function () {
            var drawerInner = cartDrawer.querySelector('.drawer__inner');
            if (drawerInner) drawerInner.classList.remove('is-empty');
            cartDrawer.classList.remove('is-empty');
          }, 100);
        } catch (e) {
          cartDrawer.open();
        }
      } else if (cartDrawer) {
        cartDrawer.open();
      }
 
      return cartData;
    }
 
    async refreshCartCount() {
      try {
        var cart = await (await fetch(this.rootUrl.replace(/\/$/, '') + '/cart.js')).json();
        /* Update all possible cart count elements in the header */
        document.querySelectorAll(
          '[data-cart-count], ' +
          '.cart-count-bubble span, ' +
          'cart-icon-bubble .badge'
        ).forEach(function (el) {
          el.textContent = cart.item_count;
        });
 
        /* Show/hide the bubble based on count */
        var bubble = document.querySelector('.cart-count-bubble, cart-icon-bubble .badge');
        if (bubble) {
          if (cart.item_count > 0) {
            bubble.removeAttribute('hidden');
            bubble.style.display = '';
          }
        }
      } catch (e) { /* theme may handle its own count */ }
    }
 
    async addToCart(row, button) {
      if (!row) return;
      var label = row.querySelector('[data-wl-atc-label]');
      var original = label.textContent;
      button.disabled = true;
      label.textContent = this.dataset.textAdding;
 
      try {
        await this.postToCart([{ id: Number(row.dataset.variantId), quantity: 1 }]);
        label.textContent = this.dataset.textAdded;
        this.toast((row.querySelector('[data-wl-title]').textContent || 'Item') + ' added to cart', true);
        window.setTimeout(function () { label.textContent = original; button.disabled = false; }, 1600);
      } catch (error) {
        label.textContent = original;
        button.disabled = false;
        this.toast(error.message);
      }
    }
 
    async addAllToCart(button) {
      var rows = Array.from(this.list.querySelectorAll('[data-wl-row]')).filter(function (r) {
        return !r.querySelector('.wl-row__atc').disabled;
      });
      if (!rows.length) return;
 
      button.disabled = true;
      try {
        await this.postToCart(rows.map(function (r) {
          return { id: Number(r.dataset.variantId), quantity: 1 };
        }));
        this.toast(rows.length + ' items added to cart', true);
        button.disabled = false;
      } catch (error) {
        this.toast(error.message);
        button.disabled = false;
      }
    }
 
    clearAll() {
      if (!window.confirm(this.dataset.textConfirmClear)) return;
      var rows = Array.from(this.list.querySelectorAll('[data-wl-row]'));
      var self = this;
 
      /* Remove each item from Smart Wishlist's backend */
      rows.forEach(function (row) {
        var productId = Number(row.dataset.productId);
        var variantId = Number(row.dataset.variantId);
        if (typeof RemoveFromSmartWishlist === 'function') {
          try { RemoveFromSmartWishlist(productId, variantId); } catch (e) { /* silent */ }
        }
      });
 
      this.list.innerHTML = '';
      this.card.hidden = true;
      this.toolbar.hidden = true;
      this.empty.hidden = false;
      this.setCount(0);
      this.updateHeaderBadge();
    }
 
    async share() {
      var url = window.location.href;
      if (navigator.share) {
        try {
          await navigator.share({ title: document.title, text: 'Check out my wishlist', url: url });
          return;
        } catch (e) { /* user dismissed or not supported — fall through to clipboard */ }
      }
      /* Clipboard fallback */
      try {
        await navigator.clipboard.writeText(url);
      } catch (e) {
        /* Last resort: create a temporary input */
        var input = document.createElement('input');
        input.value = url;
        document.body.appendChild(input);
        input.select();
        document.execCommand('copy');
        document.body.removeChild(input);
      }
      this.toast(this.dataset.textShareCopied);
    }
 
    toast(message, showCartLink) {
      var el = this.toastEl;
      if (showCartLink) {
        var cartUrl = this.rootUrl.replace(/\/$/, '') + '/cart';
        el.innerHTML = message + ' <a href="' + cartUrl + '" style="color:#fff;text-decoration:underline;margin-left:8px;font-weight:700;">View Cart →</a>';
      } else {
        el.textContent = message;
      }
      el.hidden = false;
      window.requestAnimationFrame(function () { el.classList.add('is-visible'); });
      window.clearTimeout(this._toastTimer);
      this._toastTimer = window.setTimeout(function () {
        el.classList.remove('is-visible');
        window.setTimeout(function () { el.hidden = true; }, 220);
      }, 3500);
    }
  }
 
  if (!customElements.get('wishlist-page')) {
    customElements.define('wishlist-page', WishlistPage);
  }
})();